// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1bcT-","icon":"SortAdornment_icon__Cbbnz","up":"SortAdornment_up__2LchI","down":"SortAdornment_down__Y15aA","active":"SortAdornment_active__3pXL8"};